export default __webpack_public_path__ + "static/media/five.2a67f711.jpeg";